<template>
  <AnnotateImage :src="annotate.image || contentUrl" v-if="type === 'image'" />
  <AnnotateVideo :id="id" :src="annotate.image || contentUrl" v-if="type === 'video'" />
</template>

<script setup lang="ts">
import { useViewerItemStore } from '../store/useViewerItemStore';
import { storeToRefs } from 'pinia';

import AnnotateImage from './annotations/Image.vue';
import AnnotateVideo from './annotations/Video.vue';

const store = useViewerItemStore();
const { type, contentUrl, annotate, id } = storeToRefs(store);
</script>

<style scoped>
@supports (height: 100dvh) {
  /* Image.vue and Video.vue forward this component's scope attribute to their root editor host. */
  #annotations-editor {
    height: 100dvh !important;
  }
}
</style>
